<template>
  <section class="app-main">
    <!-- 移动端跑马灯公告（所有页面顶部） -->
    <div v-if="announcements.length && device === 'mobile'" class="app-main-marquee">
      <span class="marquee-icon">📢</span>
      <div class="marquee-track">
        <div class="marquee-content" :style="marqueeStyle">
          <span v-for="(item, index) in announcements" :key="item.id" class="marquee-item">
            {{ item.announcement }}<span v-if="index < announcements.length - 1" class="marquee-sep">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
          </span>
          <span class="marquee-sep">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
          <span v-for="(item, index) in announcements" :key="'dup-' + item.id" class="marquee-item">
            {{ item.announcement }}<span v-if="index < announcements.length - 1" class="marquee-sep">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
          </span>
        </div>
      </div>
    </div>

    <transition name="fade" mode="out-in">
      <!-- <router-view :key="key"></router-view> -->
      <router-view></router-view>
    </transition>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import { fetchList } from '@/api/announcement'

export default {
  name: 'AppMain',
  data() {
    return {
      announcements: []
    }
  },
  computed: {
    ...mapGetters(['device']),
    marqueeStyle() {
      if (!this.announcements.length) return {}
      const duration = Math.max(this.announcements.length * 5, 10)
      return { animationDuration: duration + 's' }
    }
    // key() {
    //   return this.$route.name !== undefined ? this.$route.name + +new Date() : this.$route + +new Date()
    // }
  },
  created() {
    fetchList().then(res => {
      this.announcements = (res.data && res.data.list) ? res.data.list : []
    })
  }
}
</script>

<style scoped>
/* 移动端跑马灯 - 所有页面顶部 */
.app-main-marquee {
  display: flex;
  align-items: center;
  height: 32px;
  margin: 8px 12px;
  border-radius: 6px;
  background: linear-gradient(90deg, #fef7e0 0%, #fff8e8 100%);
  border: 1px solid #f0e4c0;
  overflow: hidden;
  box-sizing: border-box;
  flex-shrink: 0;
}

.app-main-marquee .marquee-icon {
  flex-shrink: 0;
  padding: 0 8px;
  font-size: 13px;
  line-height: 32px;
}

.app-main-marquee .marquee-track {
  flex: 1;
  overflow: hidden;
  position: relative;
  height: 32px;
  line-height: 32px;
  min-width: 0;
}

.app-main-marquee .marquee-content {
  display: inline-flex;
  white-space: nowrap;
  animation: app-main-marquee-scroll 15s linear infinite;
}

.app-main-marquee .marquee-item {
  color: #8b6914;
  font-size: 12px;
  flex-shrink: 0;
}

.app-main-marquee .marquee-sep {
  color: #d4b96a;
  font-size: 12px;
}

.app-main-marquee .marquee-track:hover .marquee-content {
  animation-play-state: paused;
}

@keyframes app-main-marquee-scroll {
  0% { transform: translateX(0); }
  100% { transform: translateX(-50%); }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/AppMain.vue